<script setup>
import {computed} from 'vue'

import PageEditorContentNavContent from "./PageEditorContentNavContent"
import PageEditorContentNavContentArea from "./PageEditorContentNavContentArea.vue"
import PageEditorContentNavSection from "./PageEditorContentNavSection.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const pageSections = computed(() => pageEditorStore.pageSections)

const contentAreaNames = computed(() => {
    return pageEditorStore.contentAreas
        .filter(o => o.name !== 'Page header' && o.name !== 'Page footer' && !o.sectionId)
        .map(o => o.name)
})

const sectionAreaNames = (sectionId) => {
    return pageEditorStore.contentAreas.filter(o => o.sectionId === sectionId).map(o => o.name)
}
</script>

<template>
    <div class="list-group list-group-flush">
        <PageEditorContentNavContentArea :content-area-name="'Page header'"/>
        <PageEditorContentNavContent :content-area-name="'Page header'"/>

        <template v-for="section in pageSections" :key="section.id">
            <PageEditorContentNavSection :section-id="section.id"/>
            <template v-for="areaName in sectionAreaNames(section.id)" :key="areaName">
                <PageEditorContentNavContentArea :content-area-name="areaName"/>
                <PageEditorContentNavContent :content-area-name="areaName"/>
            </template>
        </template>

        <template v-for="contentAreaName in contentAreaNames" :key="contentAreaName + '_contentArea'">
            <PageEditorContentNavContentArea :content-area-name="contentAreaName"/>
            <PageEditorContentNavContent :content-area-name="contentAreaName"/>
        </template>

        <PageEditorContentNavContentArea :content-area-name="'Page footer'"/>
        <PageEditorContentNavContent :content-area-name="'Page footer'"/>
    </div>
</template>

<style scoped>
.list-group-item {
    border-color: transparent !important;
}
</style>